import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import BackComponent from 'screens/back';
import { Table, Pagination, Tooltip, Input, CheckboxTable, Modal, Select } from 'components';
import { TrashIcon, ViewIcon, CleanIcon, AddWhiteIcon, TrashWhiteIcon, ConfirmIcon, StarIcon, GoogleMapsIcon, EditIcon } from 'assets/icons';
import { Globals, checkPermission, Constants, Print } from 'utils';
import { ClientService } from 'services';
import ModalViewClient from './modal-view-client';
import ModalLocation from './modal-location';
import CreateClient from './create-client';
import queryString from 'query-string';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: '',
	registered_in_id: '',
	user_type_id: ''
}

declare var window: any;

class Clients extends React.Component<Props> {

	timer: any = undefined;

	state = {
		form: INITIAL_STATE,
		page: 1,
		last_page: 1,
		data: [],
		header: [
			'Nombre',
			'Tipo',
			'RIF / Cédula',
			'Teléfono',
			'Correo',
			'Dirección',
			'Origen',
			'Pertenece a',
			'Acciones'
		],
		item: null,
		visible_confirm: false, 
		visible_delete: false,
		visible: false,
		visible_location: false,
		visible_bulk_confirm: false, 
		visible_bulk_delete: false,
		visible_add: false
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Clientes',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await ClientService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
		});
		this.setState({
			data: res.clients.rows,
			last_page: res.clients.count
		},() => {
			const {
				open_create
			} = queryString.parse(this.props.location.search);

			setTimeout(() => {
				if (open_create) {
					this.setState({
						visible_add: true
					},() => {
						const queryParams = new URLSearchParams(this.props.location.search);
						queryParams.delete('open_create');
						this.props.history.replace({
					        search: queryParams.toString()
					    });
					});
				}
			},500);
		});
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	view = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});
	}

	location = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible_location: true,
			item
		});
	}

	confirmDelete = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible_confirm: true,
			item
		});
	}

	delete = async () => {
		const item: any = this.state.item;
		await ClientService.admin.delete({
			user_id: item.id
		});
		await this.setState({
			visible_delete: true,
			visible_confirm: false,
			item: null
		});
		this.load(true);
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	bulkDelete = async () => {
		await ClientService.admin.bulkDelete({
			users_id: this.state.data.filter((i: any) => i.active).map((i: any) => i.id),
		});
		await this.setState({
			visible_bulk_delete: true,
			visible_bulk_confirm: false
		});
		this.load(true);
	}

	confirmBulkDelete = () => {
		this.setState({
			visible_bulk_confirm: true
		});
	}

	setActive = (index: number) => {
		let data: any = [...this.state.data];
		data[index].active = !data[index].active;
		this.setState({
			data
		});
	}

	setAllActive = () => {
		let data: any = [...this.state.data];
		if (data.filter((i: any) => i.active).length == data.length) {
			data.map((i: any) => {
				i.active = false;
				return i;
			});
		}
		else {
			data.map((i: any) => {
				if (!i.active) {
					i.active = true;
				}
				return i;
			});
		}
		this.setState({
			data
		});
	}

	onCloseConfirm = () => {
		this.setState({
			visible_confirm: false
		});
	}

	onCloseDelete = () => {
		this.setState({
			visible_delete: false
		});
	}

	onClose = () => {
		this.setState({
			visible: false
		});
	}

	onCloseLocation = () => {
		this.setState({
			visible_location: false
		});
	}

	onCloseBulkDelete = () => {
		this.setState({
			visible_bulk_delete: false
		});
	}

	onCloseBulkConfirm = () => {
		this.setState({
			visible_bulk_confirm: false
		});
	}

	downloadExcel = async () => {
		const res: any = await ClientService.admin.download({
			...this.state.form,
		});
		if (window.webkit && window.webkit.messageHandlers) {
			const message = 'open_url';
			const sendToNative = {
				message,
				url: Constants.BASE_STORAGE + res.url
			}
			const stringifiedMessageObj = JSON.stringify(sendToNative);
	        window.webkit.messageHandlers.cordova_iab.postMessage(stringifiedMessageObj);
	    }
	    else {
	    	Print(Constants.BASE_STORAGE + res.url);
	    }
	}

	add = () => {
		this.setState({
			visible_add: true
		});
	}

	onCloseAdd = () => {
		this.setState({
			visible_add: false,
			item: null
		},() => this.load(true));
	}

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible_add: true,
			item
		});
	}
	
	render() {
		const { visible_confirm, visible_delete, visible, visible_location, visible_bulk_confirm, visible_bulk_delete, visible_add } = this.state;

		return (
			<div id="clients">
				<BackComponent />

		      	<Modal
		          className="modal-moderators-confirm-delete"
		          visible={ visible_confirm }
		          title=""
		          centered
		          onClose={ () => this.onCloseConfirm() }
		        >
					<div id="modal-moderators-confirm-delete">
						<img src={ ConfirmIcon } />
						<h3>¿Está seguro de eliminar al cliente?</h3>
						<div className="row">
							<div className="col-6 text-center">
								<button className="btn" onClick={ () => this.delete() }>
									Aceptar
								</button>
							</div>
							<div className="col-6 text-center">
								<button className="btn btn-cancel" onClick={ () => {
									this.setState({
										visible_confirm: false,
										item: null
									});
								} }>
									Cancelar
								</button>
							</div>
						</div>
					</div>
		      	</Modal>

		      	<div className={ `container-modal-right ${ visible_add ? 'active' : '' }` }>
					{
						visible_add && (
							<CreateClient
								history={ this.props.history }
								item={ this.state.item }
								title={ `${ this.state.item ? 'Editar' : 'Nuevo' } Cliente` }
								onClose={ () => this.onCloseAdd() }
							/>
						)
					}
				</div>

		      	<Modal
		          className="modal-moderators-message-delete"
		          visible={ visible_delete }
		          title=""
		          centered
		          onClose={ () => this.onCloseDelete() }
		        >
					<div id="modal-moderators-message-delete">
						<img src={ StarIcon } />
						<h3>Se ha eliminado con éxito</h3>
					</div>
		      	</Modal>

		      	<Modal
		          className="modal-moderators-confirm-delete"
		          visible={ visible_bulk_confirm }
		          title=""
		          centered
		          onClose={ () => this.onCloseBulkConfirm() }
		        >
					<div id="modal-moderators-confirm-delete">
						<img src={ ConfirmIcon } />
						<h3>¿Está seguro de eliminar los clientes seleccionados?</h3>
						<div className="row">
							<div className="col-6 text-center">
								<button className="btn" onClick={ () => this.bulkDelete() }>
									Aceptar
								</button>
							</div>
							<div className="col-6 text-center">
								<button className="btn btn-cancel" onClick={ () => {
									this.setState({
										visible_bulk_confirm: false
									});
								} }>
									Cancelar
								</button>
							</div>
						</div>
					</div>
		      	</Modal>

		      	<Modal
		          className="modal-moderators-message-delete"
		          visible={ visible_bulk_delete }
		          title=""
		          centered
		          onClose={ () => this.onCloseBulkDelete() }
		        >
					<div id="modal-moderators-message-delete">
						<img src={ StarIcon } />
						<h3>Se han eliminado con éxito</h3>
					</div>
		      	</Modal>

		      	<Modal
		          className="modal-view-client"
		          visible={ visible }
		          title=""
		          centered
		          onClose={ () => this.onClose() }
		        >
					<ModalViewClient 
						item={ this.state.item }
						onClose={ () => this.onClose() }
					/>
		      	</Modal>

		      	<Modal
		          className="modal-view-client-location"
		          visible={ visible_location }
		          title=""
		          centered
		          onClose={ () => this.onCloseLocation() }
		        >
					<ModalLocation
						item={ this.state.item }
						onClose={ () => this.onCloseLocation() }
					/>
		      	</Modal>

				<div className="row row-filter">
					<div className="col-md-8">
						<div className="row">
							<div className="col-md-3">
								<Input
									searchLeft
									value={ this.state.form.search }
									name="search"
									placeholder="Nombre del cliente"
									className="input-table"
									onSubmit={ () => this.load() }
									onChange={ (e: any) => {
										clearTimeout(this.timer);
										this.timer = setTimeout(() => {
											this.load(true);
										},1000);
										this.change(e); 
									} } />
							</div>
							<div className="col-md-3">
								<Select
									placeholder="Origen"
									name="registered_in_id"
									onChange={ (e: any) => this.change(e,() => {
										this.load(true);
									}) }
									value={ this.state.form.registered_in_id }
									options={ [
										{ value: Constants.PAGES.SERVIZI.toString(), label: 'Servizi' },
										{ value: Constants.PAGES.SPLENDOR.toString(), label: 'Splendor' }
									] } />
							</div>
							<div className="col-md-3">
								<Select
									placeholder="Tipo de Usuario"
									name="user_type_id"
									onChange={ (e: any) => this.change(e,() => {
										this.load(true);
									}) }
									value={ this.state.form.user_type_id }
									options={ [
										{ value: Constants.USER_TYPES.COMMON.toString(), label: 'Común' },
										{ value: Constants.USER_TYPES.CORPORATE.toString(), label: 'Corporativo' },
										{ value: Constants.USER_TYPES.SUBUSER.toString(), label: 'Sub-Usuario' }
									] } />
							</div>
							<div className="col-md-3">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ CleanIcon } />
										</button>
									)
								}
							</div>
						</div>
					</div>
					<div className="col-md-4 text-right">
						{
							checkPermission(Constants.MODULES.SERVICES,'delete') && this.state.data.filter((i: any) => i.active).length > 0 && (
								<button className="btn btn-delete" onClick={ () => this.confirmBulkDelete() }>
									<img src={ TrashWhiteIcon } />
									Eliminar
								</button>
							)
						}
						{
							checkPermission(Constants.MODULES.CLIENTS,'write') && (
								<button className="btn btn-add" onClick={ () => this.add() }>
									<img src={ AddWhiteIcon } />
								</button>
							)
						}
					</div>
				</div>

				{
					this.state.data.length > 0 && (
						<button className="btn btn-excel" onClick={ () => this.downloadExcel() }>
							Exportar a Excel
						</button>
					)
				}

				<Table data={ this.state.data.length } header={ this.state.header } childrenHeader={
					<th>
						{
							checkPermission(Constants.MODULES.CLIENTS,'delete') && (
								<CheckboxTable 
									active={ this.state.data.filter((i: any) => i.active).length == this.state.data.length } 
									onClick={ () => this.setAllActive() } />
							)
						}
					</th>
				}>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>
									{
										checkPermission(Constants.MODULES.CLIENTS,'delete') && (
											<CheckboxTable 
												active={ i.active } 
												onClick={ () => this.setActive(index) } />
										)
									}
								</td>
								<td>{ i.full_name }</td>
								<td>{ i.user_type?.name }</td>
								<td>{ [Constants.DOCUMENT_TYPES.V,Constants.DOCUMENT_TYPES.E].indexOf(i.document_type_id) != -1 ? i.full_document : i.full_tax_document }</td>
								<td>
									<a href={ `https://wa.me/` + i.phone } target="_blank" onClick={ (e: any) => Globals.openWhatsapp(e,`https://wa.me/` + i.phone) }>
										{ i.phone }
									</a>
								</td>
								<td>{ i.email }</td>
								<td>
									{
										i.addresses?.length > 0 && (
											<Tooltip title="Dirección">
												<a className="link-icon link-google-maps" href="#" onClick={ (e: any) => this.location(e,i) }>
													<img src={ GoogleMapsIcon } />
												</a>
											</Tooltip>
										)
									}
								</td>
								<td>{ i?.registered_in?.name }</td>
								<td>{ i?.owner?.full_name || '-' }</td>
								<td>
									<Tooltip title="Ver">
										<a className="link-icon" href="#" onClick={ (e: any) => this.view(e,i) }>
											<img src={ ViewIcon } />
										</a>
									</Tooltip>
									{
										checkPermission(Constants.MODULES.CLIENTS,'write') && (
											<Tooltip title="Editar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.edit(e,i) }>
													<img src={ EditIcon } />
												</a>
											</Tooltip>
										)
									}
									{
										checkPermission(Constants.MODULES.CLIENTS,'delete') && (
											<Tooltip title="Eliminar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.confirmDelete(e,i) }>
													<img src={ TrashIcon } />
												</a>
											</Tooltip>
										)
									}
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect()(Clients);